import AuthLoadingScreen from '@platform/auth/components/AuthLoadingScreen';
import { memberPlatformLandingURL } from '@shared/utils/platformUrl';
import { type ReactElement, useEffect, useRef } from 'react';
import { isMemberUser } from '../../platform/auth/userRoles';
import { useAppSelector } from '../../store/hooks';

export default function MemberArtifactsHomePage(): ReactElement {
  const { user, isAuthenticated, token, isUserResolved, status } = useAppSelector(
    (state) => state.auth
  );
  const navigated = useRef(false);
  const admitted =
    isAuthenticated && !!token && isUserResolved && status !== 'expired' && isMemberUser(user);

  useEffect(() => {
    const navigate = () => {
      if (!admitted || navigated.current || window.__CONFIG_LOADED__ !== true) {
        return;
      }
      const config: unknown = window.__CONFIG__;
      const value =
        config && typeof config === 'object' && 'MEMBER_PLATFORM_LANDING_URL' in config
          ? config.MEMBER_PLATFORM_LANDING_URL
          : undefined;
      const destination = memberPlatformLandingURL(value);
      if (destination) {
        navigated.current = true;
        window.location.replace(destination);
      }
    };
    window.addEventListener('mento:config-loaded', navigate);
    navigate();
    return () => window.removeEventListener('mento:config-loaded', navigate);
  }, [admitted]);

  return <AuthLoadingScreen />;
}
